import { make } from 'vuex-pathify';

const debug = {
  namespaced: true,
  state: {
    orm: {
      debug: 1,
      showCount: 1,
    },
  },
  mutations: {},
  actions: {},
};

debug.mutations = make.mutations(debug.state);

export default debug;
